import type { LocaleCode } from "../types/locale-code";

import { getLocaleMetadata } from "../registry/locale-registry";

function getPostalLocationRequiredErrorMessage(localeCode: LocaleCode): string {
  return getLocaleMetadata(localeCode).country
    .postalLocationRequiredErrorMessage;
}

export { getPostalLocationRequiredErrorMessage };
